module.exports = __webpack_public_path__ + "img/sardi.16ed28fc.png";